import React, { useState, useEffect } from 'react'
import { Card, CardBody, Row, Col, FormGroup, Label } from 'reactstrap'
import { getInstructorIdData } from '../../lib/classview'
import { getInstructorIdData as getInstructorDataforSchedule } from '../../lib/scheduledays'
import { getInstructorDatawithClass } from '../../lib/sessionscheduleview'
import { getInstructorStudentwithClass } from '../../lib/instructorstudentview'
import { ScheduleNote } from './ScheduleNote'

const InstructorScheduleDays = ({ slug }) => {
	const [instructorClass, setInstructorClass] = useState([])
	const [instructorStudent, setInstructorStudent] = useState([])
	const [instructorSchedule, setInstructorSchedule] = useState([])
	const [instructorScheduleDays, setInstructorScheduleDays] = useState([])
	const [selectedClass, setSelectedClass] = useState('')
	const [, setSNote] = useState('')

	const getInstructorClassData = async () => {
		try {
			const clas = await getInstructorIdData(slug)
			if (clas[0]) {
				setInstructorClass(clas)
				setSelectedClass(clas[0].id)
				getInstructorStudentData(clas[0].id)
			}
		} catch (error) {
			console.error('Error fetching instructor class data:', error)
		}
	}

	const getInstructorStudentData = async (classId) => {
		try {
			setSNote('')
			if (classId) {
				const sched = await getInstructorDatawithClass(slug, classId)
				setInstructorSchedule(sched)

				const students = await getInstructorStudentwithClass(slug, classId)
				setInstructorStudent(students)
			}

			const schdays = await getInstructorDataforSchedule(slug)
			setInstructorScheduleDays(schdays)
		} catch (error) {
			console.error('Error fetching instructor student data:', error)
		}
	}

	const getStudentStatus = (Id, studentId) => {
		const result = instructorScheduleDays.filter((days) => {
			return days.scheduleId === Id && days.studentId === studentId
		})

		if (result.length > 0) return result[0].status
		else return ''
	}

	useEffect(() => {
		getInstructorStudentData(selectedClass)
	}, [selectedClass])

	useEffect(() => {
		getInstructorClassData()
	}, [])

	return (
		<Card>
			<CardBody>
				<div className="personal-info-head mb-5">
					<h4>Instructor Schedule</h4>
					<p></p>
				</div>

				<Row>
					<Col lg="3">
						<FormGroup>
							<Label className="form-control-label">Class</Label>
							<select value={selectedClass} onChange={(e) => setSelectedClass(e.target.value)} className="form-control">
								{instructorClass.map((data, ix) => (
									<option key={`class-${data.id}-${ix}`} value={data.id}>
										{data.class_name}
									</option>
								))}
							</select>
						</FormGroup>
					</Col>
					<Col lg="6"></Col>
				</Row>

				<hr className="mt-5" />
				<div className="comman-space pb-0">
					<div className="settings-referral-blk course-instruct-blk table-responsive">
						<table className="table">
							<thead>
								<tr>
									<th>ID</th>
									<th>Class</th>
									<th>Date</th>
									<th>Time</th>
									{instructorStudent
										? instructorStudent.map((sdata, index) => <th key={`header-${sdata.id}-${index}`}>{sdata.name + ' ' + sdata.surname}</th>)
										: ''}
									<th>-</th>
								</tr>
							</thead>
							<tbody>
								{instructorSchedule
									? instructorSchedule.map((data, ix) => (
											<>
												<tr key={`row-${data.id}`}>
													<td>{data.id}</td>
													<td>{data.class_name}</td>
													<td>{data.ldate}</td>
													<td>{data.ltime.substring(0, 5)}</td>
													{instructorStudent
														? instructorStudent.map((sdata, index) => {
																let ststatus = getStudentStatus(data.id, sdata.studentId)
																return (
																	<td key={`student-${data.id}-${sdata.studentId}-${index}`} className="mt-4">
																		<div className="select-container2 mx-2">
																			<div
																				className={
																					ststatus === 'Absent'
																						? 'select-box bg-danger-subtle'
																						: ststatus === 'Late'
																						? 'select-box bg-warning-subtle'
																						: ststatus === 'Present'
																						? 'select-box bg-success-subtle'
																						: 'select-box'
																				}
																			>
																				{ststatus === '' ? 'Select' : ststatus === 'Absent' ? 'Absent' : ststatus === 'Late' ? 'Late' : 'Present'}
																			</div>
																		</div>
																	</td>
																)
														  })
														: ''}
													<td className="text-center">
														<button
															type="button"
															className="btn btn-primary"
															data-bs-toggle="collapse"
															data-bs-target={`#collapseAnswer${ix}`}
															aria-expanded="false"
															aria-controls={`collapseAnswer${ix}`}
														>
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="16"
																height="16"
																fill="currentColor"
																className="bi bi-arrows-angle-expand"
																viewBox="0 0 16 16"
															>
																<path
																	fillRule="evenodd"
																	d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
																/>
															</svg>
														</button>
													</td>
												</tr>
												<tr key={`collapse-${data.id}`} className="collapse" id={`collapseAnswer${ix}`}>
													<td colSpan={8}>
														<ScheduleNote value={data.note ? data.note : ''} setValue={setSNote} scheduleId={data.id} />
													</td>
												</tr>
											</>
									  ))
									: ''}
							</tbody>
						</table>
					</div>
				</div>
			</CardBody>
		</Card>
	)
}

export { InstructorScheduleDays }
